import Vue from 'vue';
import Component from 'vue-class-component';
import * as i18next from 'i18next';
import * as auth from 'core/auth';
import * as api from 'core/api';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

export interface AccountBonusesComponentModel {
    state: string;
    bonuses: api.BonusStatus | null;
}

@WithRender
@Component
export default class AccountBonusesComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init

    model: AccountBonusesComponentModel = {
        state: 'loading',
        bonuses: null
    }

    mounted() {
        window.document.title = i18next.t('title_bonuses');

        this.loadModel();
    }

    loadModel() {
        this.model.state = 'loading';

        this.$auth.getBonusStatus().then(
            (result: api.BonusStatus) => {
                if (result && result.transfers.length > 0) {
                    this.model.state = 'results';
                    this.model.bonuses = result;
                } else {
                    this.model.state = 'empty';
                }
            },
            (error) => {
                this.model.state = 'error';

                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }
            }
        );
    }
}
